import * as types from '../constants/newsFeedConstants';
const initialState = {
  newsFeedData:[]
};
const updateNewsFeedData = (newsFeedData,msg) =>{
  const item =Object.assign([],newsFeedData);
  if(msg.PT==="A"){
    var obj={};
    obj.nf_id=msg.ID;
    obj.NF=msg.MSG;
    obj.URL=msg.URL;
    obj.CT=parseFloat(msg.TS);
    item.push(obj);
  }
  if(msg.PT==="E"){
      for (let index = 0; index < item.length; index++) {
          if (item[index].nf_id == msg.ID) {
                item[index].NF=msg.MSG;
                item[index].URL=msg.URL;
                item[index].CT=parseFloat(msg.TS);
                break;
            }
      }
  }
  if(msg.PT==="D")
  {
    for (let index = 0; index < item.length; index++) {
        if (item[index].nf_id == msg.ID) {
          item.splice(index,1);
          break;
        }
      }
  }
localStorage.setItem('newsFeedData', JSON.stringify(item));
return item;
};
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.SUCCESS_DEFAULT:
      return {
        ...state
      };
    case types.FAILURE_DEFAULT:
      return {
        ...state
      };
    case types.LOAD_NEWSFEED:
        return {
        ...state
      };
    case types.LOAD_NEWSFEED_SUCCESS:
      return {
        ...state,
        newsFeedData:action.result.dataObject
      };
    case types.LOAD_NEWSFEED_FAILURE:
      return {
        ...state
      };
    case types.UPDATE_NEWSFEED:
     return{
       ...state,
       newsFeedData:updateNewsFeedData(state.newsFeedData,action.message)
    }
    default:
    return state;

}
}
